import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {Tabs, Tab} from 'material-ui/Tabs';
import UserAddGeneralForm from './userAddGeneralForm';
import UserEditGeneralForm from './userEditGeneralForm';
import UserFormRoles from './userFormRoles';
import UserFormTeamsUnits from './userFormTeamsUnits';
import TabFormValidationBadge from '../../portal/tabFormValidationBadge';
import { UserEditFormMode } from '../../../services/enums/users';

@inject('translationsStore', 'addEditUserStore') @observer
export default class AddEditUsersTabs extends Component {

    state = {
        selectedTabId: -1
    };

    handleActive = (tab) => {

        this.setState({
            selectedTabId: tab.props['value']
        });
    }

    componentDidMount() {

        this.setState({
            selectedTabId: 1
        });
    }

    render(){

        const tabStyleProps = {
            className: `tab-dialog`,
            buttonStyle: { color: '#372f51' },
            style: {backgroundColor: '#fff'}
        };

        const generalTitle = this.props.translationsStore.translate('GENERAL');
        const organizationUnitsTitle = this.props.translationsStore.translate('TEAMS');
        const rolesTitle = this.props.translationsStore.translate('ROLES');

        let form = <UserAddGeneralForm />;

        if (this.props.addEditUserStore.formMode == UserEditFormMode.edit) {
            form = <UserEditGeneralForm />;
        }

        const tabs = [{
                id: 1,
                title: generalTitle,
                component: form,
                icon: null,
                dataCy: 'add-edit-users-tabs-general'
            },
            {
                id: 2,
                title: organizationUnitsTitle,
                component: <UserFormTeamsUnits />,
                icon: <TabFormValidationBadge isFormComplete={this.props.addEditUserStore.organizationUnitsFormComplete} />,
                dataCy: 'add-edit-users-tabs-teams'
            },
            {
                id: 3,
                title: rolesTitle,
                component: <UserFormRoles />,
                dataCy: 'add-edit-users-tabs-roles'
            } 
        ];

        return (
            <div style={{position: 'relative'}}>
                <Tabs className='tabs-dialog' contentContainerClassName='tabs-dialog-content-wrapper'>
                    {
                        tabs.map((tab, index) => {

                            return <Tab key={index} 
                                        {...tabStyleProps} 
                                        value={tab.id}
                                        className={`tab-dialog${this.state.selectedTabId == tab.id ? ' selected' : ''}`}
                                        style={{backgroundColor: '#fff'}} 
                                        label={tab.title}
                                        icon={tab.icon}
                                        onActive={this.handleActive}
                                        data-cy={tab.dataCy}>
                                        <div>
                                            {tab.component}
                                        </div>
                                    </Tab>

                        })
                    }
                </Tabs>
            </div>
        );
    }
}